import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "main-input",
    mixins: [validationMixin],
    props: {
        type: {
            type: String,
            default: "text",
        },
        validationRules: {
            type: Object,
        },
        onChange: {
            type: Function,
            default: () => {},
        },
        inputMask: {
            type: String,
            default: "X".repeat(100000000),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
        },
        maxlength: {
            type: String,
        },
        refs: {
            type: String,
            default: "child-input",
        },
        label: {
            type: String,
            default: "",
        },
        autocomplete: {
            type: String,
            default: "on",
        },
        name: {
            type: String,
            default: "",
        },
        inputId: {
            type: String,
            default: "",
        },
        value: {},
        focusInput: {
            type: Boolean,
            default: false,
        },
        inputmode: {
            type: String,
            default: "",
        },
        onFocus: {
            type: Function,
            default: () => {},
        },
        onBlur: {
            type: Function,
            default: () => {},
        },
        inputIcon: {
            type: String,
            default: "",
        },
    },
    mounted() {
        if (this.focusInput) {
            this.$refs[this.refs].focus();
        }
    },
    validations() {
        return {
            value: {
                ...this.transformValidationObject(),
            },
        };
    },
    computed: {
        errors() {
            let error = [];
            if (!this.$v.value.$dirty) {
                return error;
            }
            if (this.validationRules?.hasOwnProperty("required")) {
                if (!this.$v.value.required) {
                    error.push(this.$t("validationRequired"));
                }
            }
            if (this.validationRules?.hasOwnProperty("maxLength")) {
                if (!this.$v.value.maxLength) {
                    error.push(
                        this.$t("maxLengthField")
                            .replace(
                                ":field",
                                this.$t(this.placeholder || this.label).toLowerCase()
                            )
                            .replace(":count", this.validationRules.maxLength)
                    );
                }
            }
            if (this.validationRules?.hasOwnProperty("minLength")) {
                if (!this.$v.value.minLength) {
                    error.push(
                        this.$t("minLengthField")
                            .replace(
                                ":field",
                                this.$t(this.placeholder || this.label).toLowerCase()
                            )
                            .replace(":count", this.validationRules.minLength)
                    );
                }
            }
            if (this.validationRules?.hasOwnProperty("email")) {
                if (!this.$v.value.email) {
                    error.push(this.$t("validationEmail"));
                }
            }
            // if (this.validationErrors.email) {
            //     this.validationErrors.email.forEach((row) => {
            //         error.push(row);
            //     });
            // }
            return error;
        },
    },
    methods: {
        transformValidationObject() {
            const obj = this.validationRules;
            const rules = {};
            for (let i in obj) {
                if (i === "maxLength") {
                    rules[i] = maxLength(obj[i]);
                }
                if (i === "minLength") {
                    rules[i] = minLength(obj[i]);
                }
                if (i === "required") {
                    rules[i] = required;
                }
                if (i === "email") {
                    rules[i] = email;
                }
            }
            return rules;
        },
    },
};
